export default "__VITE_ASSET__iyB8sYzZ__"